import request from '../../utils/request';

export const selectXiaoqu = (url,params) => {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}

export const daoruDown = (url,dat) => {
  return request({
    url,
    method: 'get',
    params: dat
  })
}

// 通过树节点等级获取机构列表
export const deptListByLevel = (data) => {
    return request({
      url: '/api/blade-workbench/eduMatrixLevelinfo/deptListByLevel',
      method: 'post',
      data
    })
  }

export const toDaoRuData = (url,params) => {
    return request({
      url: url,
      method: 'post',
      data: params
    })
  }

export const daochuDown = (url,params) => {
  return request({
    url,
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

export const daochuSelectBT = (url) => {
  return request({
    url,
    method: 'get',
  })
}

export const daochuSelectBTPost = (url,params) => {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}
// 上传文件
export const uploadFile = (url,params) => {
  return request({
    url: url,
    method: 'post',
    data: params,
    headers: {
      "Content-Type": "multipart/form-data"
    },
  })
}

